(function ($) {
  'use strict';

  var classList = require('./classList');

  function check_behandelaar() {

    if(document.querySelector('#driejaar')) {
        var behandelaar = readCookie('isbehandelaar');
        if (behandelaar !== 'true') {
            openPopup();
        } else {
            autoplayVideo();
        }
    }

    var popup         = document.querySelector('#behandelaars-popup');
    var popup_close  = document.querySelectorAll('#behandelaars-popup .close');
    var popup_leave = document.querySelectorAll('#behandelaars-popup .leave-page');

    Array.prototype.forEach.call(popup_close, function (item) {
      item.addEventListener('click', function (ev) {
        ev.preventDefault();

        window.location = '/';

      });
    });

    Array.prototype.forEach.call(popup_leave, function (item) {
      item.addEventListener('click', function (ev) {
          ev.preventDefault();
         createCookie('isbehandelaar', true, 365);
         classList.remove(popup, 'open');
         document.getElementsByTagName('body')[0].style.overflow = '';
         autoplayVideo();
      });

    });
  }
  function openPopup() {

    var popup = document.querySelector('#behandelaars-popup');
    // Open popup here
    classList.add(popup, 'open');
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
  }

  function autoplayVideo() {
      var video_autoplay = document.querySelector('#autoplay_driejaar');
      var videoURL = video_autoplay.getAttribute("src");
      videoURL = videoURL + '&autoplay=1';
      video_autoplay.setAttribute("src",videoURL);
  }



  module.exports = check_behandelaar;

}(jQuery));
